<section class="equip-section">
  <button
    type="button"
    class="equip-toggle"
    (click)="toggleOpen()"
    [attr.aria-expanded]="isOpen()"
  >
    <ion-icon name="basketball-outline" class="equip-toggle__icon" aria-hidden="true"></ion-icon>
    <span class="equip-toggle__label">
      Equipamentos
      @if (selectedCount() > 0) {
        <span class="equip-toggle__badge">{{ selectedCount() }}</span>
      } @else {
        <span class="equip-toggle__hint">(opcional)</span>
      }
    </span>
    <ion-icon
      [name]="isOpen() ? 'chevron-up-outline' : 'chevron-down-outline'"
      class="equip-toggle__chevron"
      aria-hidden="true"
    ></ion-icon>
  </button>

  @if (isOpen()) {
    @if (loading()) {
      <div class="equip-loading" aria-live="polite">
        <ion-spinner name="crescent"></ion-spinner>
        <span>Carregando equipamentos…</span>
      </div>
    } @else if (errorMsg()) {
      <div class="equip-error" role="alert">
        <ion-icon name="alert-circle-outline"></ion-icon>
        <span>{{ errorMsg() }}</span>
      </div>
    } @else if (!hasEquipments()) {
      <div class="equip-empty">
        <ion-icon name="basketball-outline" aria-hidden="true"></ion-icon>
        <span>Nenhum equipamento disponível para este esporte.</span>
      </div>
    } @else {
      <div class="equip-grid" role="list">
        @for (eq of equipments(); track eq.id) {
          <article class="equip-card" role="listitem">
            <div class="equip-card__thumb">
              @if (eq.image) {
                <img [src]="eq.image" [alt]="eq.name" loading="lazy" />
              } @else {
                <ion-icon name="image-outline" aria-hidden="true"></ion-icon>
              }
            </div>

            <div class="equip-card__body">
              <h4 class="equip-card__name">{{ eq.name }}</h4>
              @if (eq.description) {
                <p class="equip-card__desc">{{ eq.description }}</p>
              }
              <div class="equip-card__meta">
                <span class="equip-card__price">R$ {{ eq.value | number:'1.2-2' }}</span>
                @if (getQty(eq.id) > 0) {
                  <span class="equip-card__subtotal">
                    Subtotal R$ {{ eq.value * getQty(eq.id) | number:'1.2-2' }}
                  </span>
                }
              </div>
            </div>

            <div class="equip-card__stepper" (click)="$event.stopPropagation()" (keypress)="$event.stopPropagation()">
              <lessor-quantity-stepper
                [value]="getQty(eq.id)"
                [max]="maxPerEquipment()"
                [emitOnMin]="true"
                [decLabel]="'Diminuir quantidade de ' + eq.name"
                [incLabel]="'Aumentar quantidade de ' + eq.name"
                (valueChange)="onQtyChange(eq, $event)"
              ></lessor-quantity-stepper>
            </div>
          </article>
        }
      </div>

      @if (selectedCount() > 0) {
        <div class="equip-footer">
          <span class="equip-footer__label">Total equipamentos</span>
          <span class="equip-footer__total">R$ {{ totalValue() | number:'1.2-2' }}</span>
        </div>
      }
    }
  }
</section>
